import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/logo.svg';
import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';
import { checkPaymentStatus } from '../../api/flow';
import './PaymentResultPage.scss';

const PaymentResultPage = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const [error, setError] = useState('');
  const maxRetries = 3;

  useEffect(() => {
    // Obtener el token de la URL
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');

    if (!token) {
      // Si no hay token, redirigir directamente a error
      navigate('/payment/error');
      return;
    }

    // Verificar el estado del pago con reintentos
    const verifyPayment = async (attempt = 0) => {
      try {
        const data = await checkPaymentStatus(token);

        // Estructura de respuesta: { flow: { estado, ordenFlow, ordenComercio, monto, pagador }, calcom: { estado, sincronizado } }
        const flowEstado = data.flow?.estado?.toLowerCase();

        if (flowEstado === 'pagado') {
          // Redirigir directamente a success
          navigate('/payment/success');
          return;
        } else if (flowEstado === 'pendiente') {
          // Si está pendiente, esperar y reintentar
          if (attempt < maxRetries) {
            setStatus('waiting');
            setTimeout(() => {
              verifyPayment(attempt + 1);
            }, 3000); // Esperar 3 segundos antes de reintentar
          } else {
            // Después de los reintentos, mostrar mensaje de recarga
            setStatus('waiting');
            setError(
              'El pago está pendiente de confirmación. Por favor, espera unos minutos y recarga esta página para verificar el estado, o verifica tu correo.',
            );
          }
        } else if (flowEstado === 'rechazado' || flowEstado === 'anulado') {
          // Redirigir directamente a error
          navigate('/payment/error');
          return;
        } else if (flowEstado === 'desconocido') {
          // Redirigir directamente a error
          navigate('/payment/error');
          return;
        } else {
          // Redirigir directamente a error
          navigate('/payment/error');
          return;
        }
      } catch (err) {
        console.error('Error al verificar pago:', err);

        // Si es un error de red o el pago aún no está listo, reintentar
        if (
          attempt < maxRetries &&
          (err.code === 'ECONNABORTED' || err.response?.status >= 500)
        ) {
          setStatus('waiting');
          setTimeout(() => {
            verifyPayment(attempt + 1);
          }, 3000);
        } else {
          // Si falla después de los reintentos, redirigir a error
          navigate('/payment/error');
          return;
        }
      }
    };

    // Iniciar verificación inmediatamente
    verifyPayment(0);
  }, [navigate]);

  return (
    <div className="payment-page-wrapper">
      <SEO {...getRouteMeta('/payment/result')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />

      <div className="payment-result-page">
        <div className="container">
          <div className="result-container">
            {status === 'checking' && (
              <div className="checking-state">
                <div className="spinner-large"></div>
                <h2>Verificando tu pago</h2>
                <p>
                  Estamos confirmando el estado de tu transacción. Esto puede
                  tomar unos segundos.
                </p>
                <p className="checking-hint">
                  Por favor, no cierres esta página mientras procesamos tu pago.
                </p>
              </div>
            )}

            {status === 'waiting' && (
              <div className="waiting-state">
                <div className="spinner-large"></div>
                <h2>Validando tu pago...</h2>
                <p>
                  Tu pago está siendo procesado. Esto puede tomar unos momentos.
                </p>
                {error ? (
                  <>
                    <p className="waiting-message">{error}</p>
                    <p className="reload-hint">
                      Por favor, recarga esta página para verificar el estado de
                      tu pago.
                    </p>
                    <div className="waiting-actions">
                      <button
                        className="btn-primary"
                        onClick={() => window.location.reload()}
                      >
                        Recargar Página
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <p className="waiting-message">
                      Por favor espera mientras validamos la transacción...
                    </p>
                    <p className="reload-hint">
                      Si pasan más de 2 minutos, puedes recargar esta página
                      para verificar el estado.
                    </p>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
      <Scrollbar />
    </div>
  );
};

export default PaymentResultPage;
